export default function(ac, app) {
    var entity = app.getEntity('Boja');

    entity.listView()
        .title('Boje')
        .icon('<i class="fa fa-eur fa-3x"></i>')
        .fields([
            ac.field('naziv')
                .cssClasses(['col-md-11']),
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    entity.editionView()
        .title('Boja')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true,
                    focus: true
                }
            }
        ]);

    return entity;
}



// WEBPACK FOOTER //
// ./app/components/boja/config.js